import moment from 'moment';
import React, { useCallback, useContext } from 'react';
import { styled } from 'styled-components';

import { HscanNotification } from '../../../../shared/api/hscan/notification';
import ellipseIcon from '../../assets/icons/icon_ellipse.svg';
import {
  MobilePaginationWithoutRowsPerPage,
  MobileRowsPerPage,
} from '../../common/components/MobileTable';
import { TableAndElementInformation } from '../../common/components/SortableTable/PresentationalTable';
import { ElementWrapper } from '../../common/components/SortableTable/RenderTable';

import {
  TableContext,
  TableElementContext,
  TableElementInformationProvider,
} from './NotificationTable';

export const ReadButton = styled.button<{ $isRead?: boolean }>`
  width: 20px;
  height: 38px;
  background-color: transparent;
  background-image: url(${ellipseIcon});
  background-size: 12px 12px;
  background-position: 50%;
  background-repeat: no-repeat;
  border: none;
  color: ${p =>
    p.$isRead
      ? 'var(--text_emerald, #21d89933)'
      : 'var(--text_emerald, #21d899)'};
  cursor: pointer;
`;

const ElementContainer = styled.div<{ $index: number; $read: boolean }>`
  display: flex;
  align-items: center;
  background-color: white;
  padding: 5.5px 10px;
  ${p => (p.$index > 0 ? 'border-top: darkgray' : '')};
  ${p => (p.$read ? 'opacity: 0.2' : '')}
`;
const ElementContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const ReadButtonContainer = styled.div`
  display: flex;
`;
const ElementTitle = styled.div`
  font-weight: bold;
  font-size: 12px;
`;
const ElementDate = styled.div`
  font-weight: bold;
  font-size: 11px;
`;
const ElementContent = styled.div`
  font-size: 11px;
  white-space: pre-line;
`;
interface MobileNotificationTableElementProps
  extends TableAndElementInformation<HscanNotification, 'id'> {
  onClick?: () => void;
}
export const MobileNotificationTableElement = (
  props: MobileNotificationTableElementProps,
) => {
  const { element, elementIndex, onClick } = props;
  return (
    <ElementContainer
      onClick={onClick}
      $index={elementIndex}
      $read={element.read}>
      <ElementContentContainer>
        <ElementDate>
          {moment(element.createdAt).format('YYYY.MM.DD.')}
        </ElementDate>
        <ElementTitle>{`[${element.title}]`}</ElementTitle>
        <ElementContent>{element.message}</ElementContent>
      </ElementContentContainer>
      <ReadButtonContainer>
        <ReadButton />
      </ReadButtonContainer>
    </ElementContainer>
  );
};

const ListContainer = styled.div`
  width: 100%;
`;
const NotificationWrapper = styled.div`
  background: white;
`;
interface MobileNotificationTableProps {
  verifyCode: (element: HscanNotification) => void;
}
export const MobileNotificationTable = (
  props: MobileNotificationTableProps,
) => {
  const { verifyCode } = props;
  const tableInfo = useContext(TableContext);
  const { dataToShow, identifyKey } = tableInfo;
  const Element = useCallback(
    (props: TableAndElementInformation<HscanNotification, 'id'>) => (
      <MobileNotificationTableElement
        {...props}
        onClick={() => verifyCode(props.element)}
      />
    ),
    [verifyCode],
  );
  return (
    <ListContainer>
      <MobileRowsPerPage {...tableInfo} />
      <NotificationWrapper>
        {dataToShow.map((element, elementIndex) => (
          <TableElementInformationProvider
            key={`${element[identifyKey]}`}
            element={element}
            elementIndex={elementIndex}>
            <ElementWrapper
              tableContext={TableContext}
              elementContext={TableElementContext}
              Element={Element}
            />
          </TableElementInformationProvider>
        ))}
      </NotificationWrapper>
      <MobilePaginationWithoutRowsPerPage {...tableInfo} />
    </ListContainer>
  );
};
